import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { NgMaterialModule } from '@principle-theorem/ng-material';

@Component({
  selector: 'pt-statistic-delta',
  imports: [CommonModule, NgMaterialModule],
  templateUrl: './statistic-delta.component.html',
  styleUrls: ['./statistic-delta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-row items-center',
  },
})
export class StatisticDeltaComponent {
  value = input.required<number>();
  negativeIsGood = input<boolean>(true);

  isGood = computed(() =>
    this.negativeIsGood() ? this.value() < 0 : this.value() > 0
  );
  isBad = computed(() =>
    this.negativeIsGood() ? this.value() > 0 : this.value() < 0
  );
  isNeutral = computed(() => !this.isGood() && !this.isBad());

  icon = computed(() => this._getIcon(this.value()));

  private _getIcon(value: number): string {
    if (value > 0) {
      return 'arrow_upward';
    }
    if (value < 0) {
      return 'arrow_downward';
    }
    return 'arrow_upward';
  }
}
